import { ReactNode } from 'react'

export const WIZARD_BUTTON_MIN_W = 'min-w-[180px]'

interface Props {
  children: ReactNode
  subtext?: ReactNode
}

export function WizardStepFooter({ children, subtext }: Props) {
  if (subtext) {
    return (
      <div className="flex min-h-20 flex-col justify-center gap-1 border-t border-line bg-surface px-8 py-3">
        <div className="flex w-full items-center justify-between gap-3">
          {children}
        </div>
        <p className="w-full text-center text-xs text-fg-secondary">
          {subtext}
        </p>
      </div>
    )
  }
  return (
    <div className="flex h-24 items-center justify-between gap-3 border-t border-line bg-surface px-8">
      {children}
    </div>
  )
}
